import React, { useState } from "react";

function Login1() {
    const [activeTab, setActiveTab] = useState("home");

    return (

        <section className="">
            <div className="container-fluid">
                <div className="row">
                    {/* Left Fixed Image Section */}
                    <div
                        className="col-sm-12 col-md-8 col-lg-8"
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            height: "100vh",
                            overflow: "hidden",
                            padding: 0,
                        }}
                    >
                        <img
                            src="./assets/images/login-img.svg" // replace with your image
                            alt="Fixed"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                            }}
                        />

                        <div className="lightBox1">
                            <h6>What can you do?</h6>
                            <div className="d-flex justify-content-start align-items-center py-2">
                                {/* <div><p className="mb-0">
                                    <img alt="" className="pe-1" src="./assets/images/message-square.svg" /> Send messages to Fish Farmers</p>
                                </div> */}
                                <div>
                                    <p className="mb-0">
                                        <img alt="" className="pe-1" src="./assets/images/thermometer.svg" /> Find out local pond temperature</p>
                                </div>
                                <div className="ps-5"><p className="mb-0">
                                    <img alt="" className="pe-1" src="./assets/images/time.svg" /> See updates time to time</p>
                                </div>
                            </div>
                            <p className="small mb-0">Read more about us: <a href="https://worldfishcenter.org/" target="_blank">https://worldfishcenter.org/</a></p>
                        </div>
                    </div>

                    {/* Right Data Card Section */}
                    <div
                        className="col-sm-12 col-md-4 col-lg-4 offset-lg-8 offset-md-8"
                        style={{
                            position: "relative",
                            backgroundColor: "#fff",
                            minHeight: "100vh",
                            overflowY: "auto",
                            padding: "20px 30px",
                        }}
                    >
                        <div className="logoImg mb-3">
                            <div className="d-flex justify-content-start align-items-center">
                                <div> <img loading="lazy" alt="Logo" height="40" src="./assets/images/worldfish-logo.svg" /> </div>
                                <div className="vl">
                                </div>
                                <div><h4 className="nav-title mb-0">Blue Resilience / Ulimi Wansomba</h4></div>
                            </div>
                        </div>
                        <div className="login-box">
                            <h1 className="nav-title-1 mb-0">Tailored decision support platform for aquatic food systems</h1>
                            <h4><span className="text-dark" style={{ fontSize: '12px' }}>
                                <span className="mb-0" style={{ color: 'rgb(28, 72, 107)', fontSize: '14px' }}><strong>Blue Resilience / Ulimi Wansomba</strong></span>
                                &nbsp; Generates and communicates climate information and advisory services to enable climate-informed decision-making
                                at different scales — from small-scale fish farmers to policy makers — paving the way for climate risk management
                                initiatives for aquatic foods in the SADC region.</span>
                            </h4>

                            <form action="" className="row pt-1">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label for="" className="mb-1">Login</label>
                                        <input className="form-control h40px mt-1" placeholder="Email or phone number" required="" type="text" value="admin.mwi@domain.com" />
                                    </div>
                                    <div className="form-group">
                                        <label for="" className="mb-1">Password</label>
                                        <input className="form-control h40px mt-1" placeholder="Enter password" type="password" value="ProF!sh.mwi2025" />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div><a href="#" className="float-end text-primary1">Forgot Password?</a></div>
                                </div>
                                <div className="col-12 text-center">
                                    <button type="submit" className="btn btn-login px-4 float-end mt-3 w-100">Login</button>
                                </div>
                            </form>
                            <div className="loginFooterLogo mt-2 pt-2">
                                <div className="d-flex">
                                    <img alt="" height="35px" src="./assets/images/login-footer-1.svg" />
                                    <img className="ms-2" alt="" height="35px" src="./assets/images/sadc.png" />
                                </div>
                                <div className="mt-2 d-flex">
                                    <img height="35px" alt="" src="./assets/images/top-login-logo.svg" />
                                    <img className="mx-2" height="35px" src="./assets/images/footer-2.png" />
                                    <img height="35px" alt="" src="./assets/images/AICCRA.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default Login1;

